import type {
  ConfirmingRequestById,
  DocumentFromConfirmingRequestById,
} from 'lib/api/confirming/types';

import type {
  ConfirmingRequestForCreation,
  ConfirmingRequestForCreationDocument,
} from '../types';

const DEFAULT_SUB_PRODUCT = 'electronic-invoice-confirming';
const DEFAULT_SUB_PRODUCT_NAME = 'Factura electrónica confirming';

function toProductType(type: string): 'traditional' | 'earlyPayment' {
  return type === 'earlyPayment' ? 'earlyPayment' : 'traditional';
}

function mapDocument(
  doc: DocumentFromConfirmingRequestById,
  request: ConfirmingRequestById,
): ConfirmingRequestForCreationDocument {
  const paymentDate =
    typeof doc.paymentDate === 'string'
      ? new Date(doc.paymentDate)
      : doc.paymentDate;

  return {
    id: doc.id,
    amount: doc.amount,
    businessIdentifier: doc.businessIdentifier,
    businessName: doc.businessName,
    issuer: doc.issuer,
    issuedDate: doc.issuedDate,
    receiptDate: doc.receiptDate ?? '',
    issuedDateShortString: doc.issuedDateShortString,
    daysToCount: doc.daysToCount,
    confirmDate: doc.confirmDate ?? false,
    cedded: doc.cedded,
    folio: doc.folio,
    paymentDate,
    paymentDateString: paymentDate ? paymentDate.toISOString() : '',
    paymentDateShortString: doc.paymentDateShortString,
    cancelDate: doc.cancelDate ?? false,
    stakeholderName: request.stakeholderName,
    stakeholderIdentifier: doc.stakeholderIdentifier,
    active: doc.active,
    code: doc.subType,
    userOwnerId: request.userOwner?.id ?? request.userOwnerId ?? undefined,
  };
}

/**
 * Adapta la respuesta de get-by-id al shape que usa el simulador y los cálculos de totales.
 */
export function mapConfirmingRequestByIdToForCreation(
  request: ConfirmingRequestById,
): ConfirmingRequestForCreation {
  return {
    id: request.id,
    advance: request.advance ?? 100,
    rate: request.rate ?? 0,
    arrearType: request.arrearType,
    arrearRate: request.arrearRate ?? 0,
    arrearTableId: request.arrearTableId,
    expensesHasIva: request.expensesHasIva ?? false,
    expensesHasIVA: request.expensesHasIva ?? false,
    stakeholderIdentifier: request.stakeholderIdentifier,
    stakeholderName: request.stakeholderName,
    amount: request.amount,
    subProduct: request.subProductId ?? DEFAULT_SUB_PRODUCT,
    subProductName: DEFAULT_SUB_PRODUCT_NAME,
    productType: toProductType(request.type),
    documents: request.documents.map((doc) => mapDocument(doc, request)),
    requestDate: request.operationDate || request.createdAt,
    userOwnerId: request.userOwnerId ?? request.userOwner?.id ?? undefined,
    userOwner: request.userOwner ? { id: request.userOwner.id } : undefined,
    exchangeDays: request.exchangeDays,
    fundRate: request.fundRate ?? 0,
    operationCostComissionFixed: request.operationCostFixed ?? undefined,
    operationCostComissionVariable: request.operationCostVariable ?? undefined,
    operationCostComissionVariablePercentage:
      request.operationCostVariablePercentage ?? undefined,
    operationCostFixed: request.operationCostFixed ?? undefined,
    operationCostVariable: request.operationCostVariable ?? undefined,
    expensesCost: request.expensesCost,
    operationCostVariablePercentage:
      request.operationCostVariablePercentage ?? undefined,
  };
}
